// extracted by mini-css-extract-plugin
module.exports = {"waffle":"waffle___3nPTZ","loading":"loading___1Wd5m","waffle-verticalScrollDisabled":"waffle-verticalScrollDisabled___2z-Or"};